import { apiV2 } from "@/lib/apiV2/apiV2";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

export const useRegionsV2 = () => {
  const {
    data: regionsData,
    error: regionsError,
    isFetching: loadingRegions,
  } = useQuery({
    queryKey: ["regions"],
    queryFn: apiV2.tags.platform.getRegionTags,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const regions = regionsData?.data || [];

  const regionOptions = useMemo(
    () =>
      regions
        .map((region) => ({
          label: region.name,
          value: region.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [regions]
  );

  return { regions, regionsError, loadingRegions, regionOptions };
};
